window['ThemeSection_header'] = (count) => {

  return {
    headerIsSticky: false,
    scrollY: 0,
    get isStuck() {
      return this.headerIsSticky && this.scrollY > 100;
    },
    mounted() {
      initTeleport(this.$root);
      Alpine.store('peak', false);

      document.addEventListener('shopify:section:load', (e) => {
        if (!e.target.querySelector('#headerContainer')) return;
        this.calculateContainerHeight();
      });

      if (this.$root.hasAttribute('data-sticky-header')) {
        this.setUpSticky();
      }
      
    },
    calculateContainerHeight() {
    },
    setUpSticky() {
      const headerContainer = document.getElementById('shopify-section-header');
      const observer = new IntersectionObserver(
        (e) => {
          e.forEach((entry) => {
            this.headerIsSticky = entry.intersectionRatio < 1 ? true : false;
          });
        },
        {
          rootMargin: '-1px 0px 0px 0px',
          threshold: [1],
        }
      );
      observer.observe(headerContainer);
      let timer = null;
      const checkScrollPosition = (e) => {
        this.scrollY = window.scrollY;
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.scrollY = window.scrollY;
        }, 150);
      };
      const _debounceScrollHandler = throttle(checkScrollPosition, 150);
      document.addEventListener('scroll', _debounceScrollHandler);
      this.scrollY = window.scrollY;
    }
  };
};
